import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import FloatingContactButtons from "components/FloatingContactButtons";

// Direct imports - no lazy loading
import Homepage from './pages/homepage';
import ServiceSelection from './pages/service-selection';
import RouteSelection from './pages/route-selection';
import CarSelection from './pages/car-selection';
import CarDetails from './pages/car-details';
import EnquiryDetails from './pages/enquiry-details';
import SearchResults from './pages/search-results';
import ContactSupport from './pages/contact-support';
import UserDashboard from './pages/user-dashboard';
import RouteDetails from './pages/route-details';
import TourPackageDetails from './pages/tour-package-details';
import TourPackageBooking from './pages/tour-package-booking';
import TempoTravellerDetails from './pages/tempo-traveller-details';
import TempoTravellerBooking from './pages/tempo-traveller-booking';
import ForceUrbaniaDetails from './pages/force-urbania-details';
import DelhiToLudhiana from './pages/delhi-to-ludhiana';
import PopularCities from './pages/popular-cities';
import CityDetail from './pages/city-detail';
import TourPackagesMain from './pages/tour-packages-main';
import TourPackageCity from './pages/tour-package-city';
import TempoTravellerMain from './pages/tempo-traveller-main';
import TempoTravellerCity from './pages/tempo-traveller-city';
import ForceUrbaniaMain from './pages/force-urbania-main';
import ForceUrbaniaCity from './pages/force-urbania-city';
import LocalCabMain from './pages/local-cab-main';
import LocalCabCity from './pages/local-cab-city';
import SelfDriveMain from './pages/self-drive-main';
import SelfDriveCity from './pages/self-drive-city';
import SelfDriveEnquiry from './pages/self-drive-enquiry';
import WeddingCar from './pages/wedding-car';
import YatraMain from './pages/yatra-main';
import YatraCity from './pages/yatra-city';
import YatraBooking from './pages/yatra-booking';
import DailyPickDrop from './pages/daily-pick-drop';
import MonthlyCabService from './pages/monthly-cab-service';
import CorporateCarRental from './pages/corporate-car-rental';
import OurCabs from './pages/our-cabs';
import AboutUs from './pages/about-us';
import ContactUs from './pages/contact-us';
import FAQ from './pages/faq';
import Blogs from './pages/blogs';
import Reviews from './pages/reviews';
import OneWayBooking from './pages/one-way-booking';
import BookingConfirmation from './pages/booking-confirmation';
import VehicleDetails from './pages/vehicle-details';
import TempoTravellerAmritsar from './pages/tempo-traveller-amritsar';
import TempoTravellerRouteBooking from './pages/tempo-traveller-route-booking';
import ForceUrbaniaRouteBooking from './pages/force-urbania-route-booking';
import RouteDynamicDetails from './pages/route-details-dynamic';
import NotFound from './pages/NotFound';

function Routes() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <FloatingContactButtons />
        <RouterRoutes>
          <Route path="/" element={<Homepage />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/service-selection" element={<ServiceSelection />} />
          <Route path="/route-selection" element={<RouteSelection />} />
          <Route path="/car-selection" element={<CarSelection />} />
          <Route path="/car-details" element={<CarDetails />} />
          <Route path="/enquiry-details" element={<EnquiryDetails />} />
          <Route path="/search-results" element={<SearchResults />} />
          <Route path="/contact-support" element={<ContactSupport />} />
          <Route path="/user-dashboard" element={<UserDashboard />} />
          <Route path="/route-details" element={<RouteDetails />} />
          <Route path="/tour-package-details" element={<TourPackageDetails />} />
          <Route path="/tour-package-booking/:cityName/:destination" element={<TourPackageBooking />} />
          <Route path="/tempo-traveller-details" element={<TempoTravellerDetails />} />
          <Route path="/tempo-traveller-booking/:route" element={<TempoTravellerBooking />} />
          <Route path="/force-urbania-details" element={<ForceUrbaniaDetails />} />
          <Route path="/delhi-to-ludhiana" element={<DelhiToLudhiana />} />
          <Route path="/popular-cities" element={<PopularCities />} />
          <Route path="/city-detail/:cityName" element={<CityDetail />} />
          <Route path="/tour-packages" element={<TourPackagesMain />} />
          <Route path="/tour-packages/:cityName" element={<TourPackageCity />} />
          <Route path="/tempo-traveller" element={<TempoTravellerMain />} />
          <Route path="/tempo-traveller/:cityName" element={<TempoTravellerCity />} />
          <Route path="/force-urbania" element={<ForceUrbaniaMain />} />
          <Route path="/force-urbania/:cityName" element={<ForceUrbaniaCity />} />
          <Route path="/force-urbania-booking/:route" element={<ForceUrbaniaRouteBooking />} />
          <Route path="/local-cab" element={<LocalCabMain />} />
          <Route path="/local-cab/:cityName" element={<LocalCabCity />} />
          <Route path="/self-drive" element={<SelfDriveMain />} />
          <Route path="/self-drive/:cityName" element={<SelfDriveCity />} />
          <Route path="/self-drive-enquiry" element={<SelfDriveEnquiry />} />
          <Route path="/wedding-car" element={<WeddingCar />} />
          <Route path="/yatra" element={<YatraMain />} />
          <Route path="/yatra/:cityName" element={<YatraCity />} />
          <Route path="/yatra-booking/:cityName/:destination" element={<YatraBooking />} />
          <Route path="/daily-pick-drop" element={<DailyPickDrop />} />
          <Route path="/monthly-cab-service" element={<MonthlyCabService />} />
          <Route path="/corporate-car-rental" element={<CorporateCarRental />} />
          <Route path="/our-cabs" element={<OurCabs />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/one-way-booking" element={<OneWayBooking />} />
          <Route path="/booking-confirmation" element={<BookingConfirmation />} />
          <Route path="/vehicle-details" element={<VehicleDetails />} />
          <Route path="/tempo-traveller-amritsar" element={<TempoTravellerAmritsar />} />
          <Route path="/tempo-traveller-route-booking/:route" element={<TempoTravellerRouteBooking />} />
          <Route path="/force-urbania-route-booking/:route" element={<ForceUrbaniaRouteBooking />} />
          <Route path="/route/:routeName" element={<RouteDynamicDetails />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default Routes;